exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.display-contents[data-v-6cf92756] {\n    display: contents;\n}\n.option__image[data-v-6cf92756] {\n    max-width: 30px;\n    max-height: 20px;\n}\n", ""]);

// exports
